import 'Shared/FrameModules/MediaLibrary/library.js';
import 'Shared/FrameModules/MediaLibrary/item.js';
import 'Shared/FrameModules/MediaLibrary/target.js';
import 'Shared/FrameModules/MediaLibrary/text_target.js';
import 'Shared/FrameModules/MediaLibrary/minimal_target.js';
import 'Shared/FrameModules/MediaLibrary/media_manager.js';
import 'Shared/FrameModules/MediaLibrary/item_menu.js';
import 'Shared/FrameModules/MediaLibrary/item_image.js';
import 'Shared/FrameModules/MediaLibrary/item_document.js';
import 'Shared/FrameModules/MediaLibrary/video_item.js';
import 'Shared/FrameModules/MediaLibrary/item_embed.js';
